// const baseUrl = 'http://103.203.137.244/v1'
const baseUrl = 'http://15.206.151.70/v1'

export default baseUrl
